module.exports = __webpack_public_path__ + "img/indesign.383cd18c.svg";